"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorChartHeadingStyled = exports.ContainerStyled = exports.ListStyled = exports.ItemStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _container = require("@dbi-tools/ui-kit/lib/components/container");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 40px;\n  line-height: 48px;\n  ", " {\n    font-size: 32px;\n    line-height: 40px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 60px 27px;\n    padding-bottom: ", ";\n    padding-top: ", ";\n\n    ", " {\n      padding: 30px 24px;\n      padding-bottom: ", ";\n      padding-top: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 30px -15px 0;\n\n  ", " {\n    justify-content: space-around;\n  }\n\n  ", " {\n    margin: 30px -7.5px 0;\n    justify-content: flex-start;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0 15px 30px;\n  text-decoration: none;\n  cursor: pointer;\n  outline: none;\n  width: ", "px;\n\n  ", " {\n    width: ", "px;\n  }\n\n  ", " {\n    margin: 0 7.5px 30px;\n    width: calc(33.33% - 15px);\n  }\n\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var mobileBlockSize = 99;
var desktopBlockSize = 109;
var ItemStyled = (0, _uiKit.styled)('a')(_templateObject(), desktopBlockSize, _uiKit.GridBreakpointsMediaDown.md, mobileBlockSize, _uiKit.GridBreakpointsMediaDown.sm, _uiKit.TextStyled, _uiKit.Colors.wine);
exports.ItemStyled = ItemStyled;
var ListStyled = (0, _uiKit.styled)('div')(_templateObject2(), _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.sm);
exports.ListStyled = ListStyled;
var ContainerStyled = (0, _uiKit.styled)(_container.Container)(_templateObject3(), function (_ref) {
  var removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding;
  return (0, _uiKit.css)(_templateObject4(), removeBottomPadding ? 0 : '60px', removeTopPadding ? 0 : '60px', _uiKit.GridBreakpointsMediaDown.sm, removeBottomPadding ? 0 : '30px', removeTopPadding ? 0 : '30px');
});
exports.ContainerStyled = ContainerStyled;
var ColorChartHeadingStyled = (0, _uiKit.styled)(_uiKit.HeadingStyled)(_templateObject5(), _uiKit.GridBreakpointsMediaDown.md);
exports.ColorChartHeadingStyled = ColorChartHeadingStyled;